import { render, staticRenderFns } from "./Compare.vue?vue&type=template&id=21e1d774&scoped=true&"
import script from "./Compare.vue?vue&type=script&lang=js&"
export * from "./Compare.vue?vue&type=script&lang=js&"
import style0 from "./Compare.vue?vue&type=style&index=0&id=21e1d774&prod&lang=sass&rel=stylesheet%2Fsass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e1d774",
  null
  
)

export default component.exports